export const APP_CONFIG = {
    appId: 'kindergarten_parent_app',
    appType: 'end_user',
    institutionType: 'kindergarten',
    apiPath: '/apis/kindergarten-app',
    titleSuffix: 'KigaRoo',
    privacyUrl: null as string | null,
    appVersion: '16.0.0',
    clientLogoFileName: 'logo.svg',
    staticLogo: false,
    organization: null as number | null,
    federationIds: null as number[] | null,
    pushChannelName: 'KigaRoo – Kinder in guten Händen',
    firebase: {
        apiKey: 'AIzaSyAssTES9uL0Fl4F26IuwQ1uyhxlgnjSfjA',
        projectId: 'speicherhafen',
        messagingSenderId: '1087915507372',
        appId: '1:1087915507372:web:60b18aeffacc6d9ae72909',
    },
    sentryEnvironment: 'kindergarten-parent-app',
    // Vue path only (`/app`); Angular additionally matched the legacy `/mitarbeiter` dual path.
    appUrlRegex:
        /^https?:\/\/(?:localhost:9411\/app|www\.kigaroo\.de\/app|app\.kigaroo\.de\/app|stage\d+\.kigaroo\.com\/app)(?:\/de|\/en|\/fr)?(.*)/,
    platformOrganization: {
        name: 'Speicherhafen GmbH & CO. KG',
        street: 'Am Sandtorkai 1',
        zip: '20457',
        city: 'Hamburg',
        email: 'support@kigaroo.de',
        phone: '+49 (0)40 30 30 66 999',
        fax: '+49 (0)40 30 30 66 996',
        homepage: 'https://www.kigaroo.de',
        executives: 'Dipl. iur. Moritz von Bismarck, MBA',
    },
} as const;
